import { buttonPositions } from "./buttonPositions"

export const handleVisibility = (button, hide) => {
    if (hide) {
        button.style.opacity = 0
        button.style.pointerEvents = 'none'
    } else {
        button.style.opacity = 1
        button.style.pointerEvents = 'auto'
    }
}

export const handlePosition = (button, position, close, opacity=null, overflow=null) => {
    if (close) {
        button.style.left = 0
        button.style.top = 0
        button.style.width = '50px'
        button.style.pointerEvents = 'none'
        if (opacity !== null) {
            button.style.opacity = opacity
        }
        if (overflow) {
            button.style.pointerEvents = 'auto'
            button.style.overflow = 'visible'
        }
    } else {
        button.style.left = position.left
        button.style.top = position.top
        button.style.width = ''
        button.style.overflow = 'hidden'
    }
}

export const setButtonPositions = (buttons) => {
    let totalButtons = buttons.length.toString()
    let positions = buttonPositions[totalButtons]
    buttons.forEach((button, i) => {
        button.props.position = positions[i]
        button.props.index = i
    })
    return buttons
}